<mat-dialog-content class="make-a-payment-wrapper">
  <div class="header">
    <div class="dialog-close-row flex-row flex-center-space-between">
      <div class="mat-headline-4">Make a Payment</div>
      <mat-icon class="close-icon pointer" (click)="cancel()">close</mat-icon>
    </div>
  </div>
  <div class="body" id="payment-form">
    <div class="flex flex-row amount-row">
      <rv-currency-form-field fieldName="amount" [externalLabel]="true" [formGroup]="paymentForm" class="amount-field"/>
    </div>
    <div id="payment-status-container"></div>
    <div id="card-container"></div>
    <div class="button-row flex-row flex-center-end">
      <button mat-stroked-button class="save-button-group button-cancel" (click)="cancel()">
        Cancel
      </button>
      <button mat-raised-button color="primary" class="save-button-group"
              [disabled]="!paymentForm.valid" (click)="onClickPay()">
        <span>Submit</span>
      </button>
    </div>
  </div>
</mat-dialog-content>
